// TODO: fix tree-shaking
// TODO: import { SportsApiEndpoints } from '@collector/sportsapi-types'
export const SportsApiEndpoints = new RegExp(
  '(?!https?://(?:api-scouts.statscore.com|api.beta.statscore.com|dev.api.statscore.com)/).*$',
)

export function isSportsApiUrl(url: string): boolean {
  return SportsApiEndpoints.test(url)
}
